import { twMerge } from "tailwind-merge";
import { ReactElement } from "react";
import { useSearchParams } from "react-router";
import { Card } from "@sellar-io/components";
import { useSellarSession } from "../../../../hooks/useSellarSession";
import { UserSignupFlow } from "../../signIn/UserSignupFlow";
import { UserSignupStepSupplier } from "./UserSignupStepSupplier";

export function UserSignupStep(): ReactElement {
  const [searchParams] = useSearchParams();
  const { state } = useSellarSession();
  if (
    searchParams.get("supplierId") &&
    state.status !== "initialization-error" &&
    state.status !== "retrying-initialization"
  )
    return (
      <div className={"flex h-full w-full items-center justify-center"}>
        <Card
          className={twMerge(
            "bg-white",
            "flex h-full w-full flex-col p-8 md:h-4/5 md:w-[480px]",
          )}
        >
          <UserSignupStepSupplier
            supplierIdOrUrlId={searchParams.get("supplierId") ?? ""}
          />
        </Card>
      </div>
    );

  return (
    <div className={"flex h-full w-full items-center justify-center"}>
      <Card
        className={twMerge(
          "bg-white",
          "flex h-screen w-full flex-col overflow-hidden p-8 lg:h-4/5 lg:max-h-[768px] lg:w-[480px]",
        )}
      >
        <UserSignupFlow />
      </Card>
    </div>
  );
}
